import { render, staticRenderFns } from "./SidebarNav.vue?vue&type=template&id=a9b1e1a4&"
import script from "./SidebarNav.vue?vue&type=script&lang=ts&"
export * from "./SidebarNav.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports